import { useMemo } from 'react';
import { getTranslations, type AppTranslations } from '@/locales';
import { useSurveyLanguage } from './useSurveyLanguage';

/**
 * Returns the full translations object `t` for the current survey language.
 *
 * Usage in any page:
 *   const { t } = useTranslation();
 *   <p>{t.ageSmoker.smokerQuestion}</p>
 */
export function useTranslation(): { t: AppTranslations } {
  const { surveyLanguage } = useSurveyLanguage();
  const t = useMemo(
    () => getTranslations(surveyLanguage ?? 'en'),
    [surveyLanguage]
  );
  return { t };
}
